import { composeThemeFromProps, Compose } from '@css-modules-theme/react';
import clsx from 'clsx';
import React, { forwardRef, useMemo, Children } from 'react';
import defaultStyles from './styles/Grid.module.scss.js';
import { jsx, Fragment } from 'react/jsx-runtime';
import { omit } from '../../utils/omit.js';
import { isObject } from '../../utils/is.js';

const Row = /*#__PURE__*/forwardRef(({
  theme,
  variant = 'nospace',
  style,
  children,
  xs,
  sm,
  md,
  lg,
  xl,
  align = 'start',
  justify = 'start',
  direction = 'row',
  ...rest
}, ref) => {
  const styles = composeThemeFromProps(defaultStyles, {
    theme
  }, {
    compose: Compose.Merge
  });
  function generateRowClasses() {
    const screenList = {
      xs,
      sm,
      md,
      lg,
      xl
    };
    let responsiveClasses = '';
    Object.keys(screenList).forEach(screen => {
      const screenValue = screenList[screen];
      if (isObject(screenValue)) {
        responsiveClasses += clsx(' ', {
          [styles[`row_${screen}_direction_${screenValue.direction}`]]: screenValue.direction,
          [styles[`row_${screen}_align_${screenValue.align}`]]: screenValue.align,
          [styles[`row_${screen}_justify_${screenValue.justify}`]]: screenValue.justify,
          [styles[`row_${screen}_variant_${screenValue.justify}`]]: screenValue.variant === 'spaced'
        });
      }
    });
    return responsiveClasses;
  }
  let rowClassNames = clsx(styles.row, {
    [styles[`row_align_${align}`]]: align,
    [styles[`row_justify_${justify}`]]: justify,
    [styles[`row_direction_${direction}`]]: direction,
    [styles[`row_variant_${variant}`]]: variant === 'spaced'
  });
  rowClassNames += clsx(generateRowClasses());
  const childrenWithProps = useMemo(() => Children.map(children, child => {
    // Checking isValidElement is the safe way and avoids a TS error too.
    if ( /*#__PURE__*/React.isValidElement(child)) {
      return /*#__PURE__*/React.cloneElement(child, {
        ...child.props,
        variant
      });
    }
    return child;
  }), [children, variant]);
  return /*#__PURE__*/jsx(Fragment, {
    children: /*#__PURE__*/jsx("div", {
      ref: ref,
      ...omit(rest, ['gutter']),
      style: {
        ...style
      },
      className: rowClassNames,
      children: childrenWithProps
    })
  });
});
Row.displayName = 'Row';

export { Row };
